export default __webpack_public_path__ + "static/media/message.7514ec63.svg";